import * as React from "react";
import './WPTable.css'
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {WPTableSortDirectionEnum, WPTH} from "shared/controls/WPTable/WPTH";
import {SortSnippets} from "shared/utilities/Snipets/SortSnippets";
import {Children, ReactNode} from "react";
import {WPPagination} from "shared/controls/WPTable/WPPagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
import {library} from "@fortawesome/fontawesome-svg-core";
import {WPTR} from "shared/controls/WPTable/WPTR";
library.add(faSpinner);

export class WPTable extends React.Component<WordpressTableProps, WordpressTableState> {
    static defaultProps: Partial<WordpressTableProps> = {
        ActionClicked:null,
        EmptyContent:null,
        RowsCount:0,
        PageIndex:0,
        Size:0,
        IsBusy:false,
        BulkActions:[]

    };
    public Columns:WPBasicColumn[];
    constructor(props: WordpressTableProps) {
        super(props);
        this.state= {
            SortDirection:WPTableSortDirectionEnum.none,
            SortColumnName:''
        };
        this.CreateColumnList(props);

    }

    componentWillReceiveProps(nextProps: Readonly<WordpressTableProps>, nextContext: any): void {
        let oldChildrens =Children.toArray(this.props.children);
        let newChildrens =Children.toArray((nextProps as any).children);

        if(oldChildrens.length!=newChildrens.length)
        {
            this.CreateColumnList( (nextProps as any));
            return;
        }

        for(let i=0;i<oldChildrens.length;i++)
        {
            if((oldChildrens[i] as any).key!=newChildrens[i].key) {
                this.CreateColumnList((nextProps as any));
                return;
            }

        }



    }

    public render() {
        let data=this.props.Data;
        if(this.state.SortDirection!=WPTableSortDirectionEnum.none&&this.state.SortColumnName!='')
        {
            data=SortSnippets.SortByProperty(data,this.state.SortColumnName,this.state.SortDirection);
        }

        return (
            <div>
                <div className="tablenav top">
                    {this.CreatePagination()}
                </div>
                <div style={{position:'relative',overflow:'auto',display:'block',marginTop:20}}>
                    <table className={'wp-list-table widefat fixed striped entries'} style={{minWidth:this.Columns.reduce((previousValue, currentValue) => {return previousValue+currentValue.props.Width},0)}}>
                        <thead>
                            <tr>
                                {this.Columns.map(x=>
                                    <WPTH Styles={{...x.props.HeaderStyle, width:x.props.Width}}  key={x.props.PropertyName} IsSortable={x.props.IsSortable} SortingChanged={e=>this.ShortChanged(x.props.PropertyName,e)} SortDirection={this.state.SortColumnName==x.props.PropertyName?this.state.SortDirection:WPTableSortDirectionEnum.none} >
                                        {x.props.Title}
                                    </WPTH>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.Data.length==0&&this.props.EmptyContent!=null&&
                                <tr>
                                    <td colSpan={this.Columns.length}>{this.props.EmptyContent}</td>
                                </tr>
                            }
                        {this.props.Data.length>0&&this.props.Data.map((row,index)=>
                            <WPTR key={index} WPTable={this} Data={row} Index={index}/>

                        )}

                        </tbody>
                    </table>
                    {this.props.IsBusy&&
                        <div style={{position: "absolute", top: 0, left: 0, width: '100%', height: '100%'}}>
                            <div style={{width: '100%', height: '100%', backgroundColor: 'black', opacity: .5}}/>
                            <div style={{
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <h1 style={{color: 'white'}}><FontAwesomeIcon icon={"spinner"} spin={true}/> Loading...
                                </h1>
                            </div>
                        </div>
                    }
                </div>
                <div className="tablenav top">
                    {this.CreatePagination()}
                </div>
            </div>
        )
    }

    private ShortChanged(PropertyName: string, e: WPTableSortDirectionEnum) {

        this.setState({
            SortColumnName:PropertyName,
            SortDirection:e
        })
    }

    private CreatePagination() {
        return <WPPagination BulkActions={this.props.BulkActions} PageIndex={this.props.PageIndex} RowsCount={this.props.RowsCount} Size={this.props.Size} PageChanged={this.props.PageChanged}/>
    }

    private CreateColumnList(props:any) {
        let array=React.Children.toArray(props.children) as any;
        this.Columns=[];
        for(let item of array)
        {
            this.Columns.push(new item.type(item.props));
        }

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressTableProps {
    Data:any[];
    ActionClicked:(actionId:string,row:any)=>void;
    RowClicked?:(row:any)=>void;
    EmptyContent?:ReactNode;
    RowsCount:number;
    Size:number;
    PageIndex:number;
    PageChanged:(pageIndex:number)=>void;
    IsBusy:boolean;
    BulkActions:BulkActions[];
}

interface WordpressTableState {
    SortColumnName:string;
    SortDirection:WPTableSortDirectionEnum;
}


export interface BulkActions {
    Title:string;
    CallBack:()=>boolean|Promise<boolean>;
}

//#endregion "My Region"